

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OtpVerification from "../Pages/Auth/otpVerification";
import BookingsManager from "../Pages/Booking/bookingsManager";
import UserDashboard from "../Pages/User/dashboard";
import UserProfile from "../Pages/User/profile";
import StoreProfile from "../Pages/Booking/storeProfile";
import DoorstepService from "../Pages/Booking/doorstepService";
import MessengerList from "../Pages/Messenger/messengerList";
import SearchStore from "../Pages/Search/searchStore";
import SearchStoreProfile from "../Pages/Search/searchStoreProfile";


import MapView from "../Pages/Search/mapView";
import AddFamilyMember from "../Pages/User/addFamilyMember";
import FindLocation from "../Pages/Search/findLocation";
import Transactions from "../Pages/User/transaction";
import AboutPingle from "../Pages/aboutPingle";
import NotificationList from "../Pages/Messenger/notificationList";
import VendorProfile from "../Pages/Booking/vendorProfile";
import EditProfileMenu from "../Pages/User/profile-edit/editProfileMenu";
import EditProfileUser from "../Pages/User/profile-edit/editProfileUser";
import EditProfileEmailVerify from "../Pages/User/profile-edit/editProfileEmailVerify";
import EditProfileAadhar from "../Pages/User/profile-edit/editProfileAadhar";
import BookingSelectStaff from "../Pages/Booking/bookingSelectStaff";
import ReviewAndPay from "../Pages/Booking/reviewAndPay";
import BulletinBoard from "../Pages/User/bulletinBoard";
import UserMembership from "../Pages/User/membership";
import Products from "../Pages/Products/product";
import ReviewPay from "../Pages/Products/Reviewpay";
import ProductBasket from "../Pages/Products/productBasket";
import SingleProduct from "../Pages/Products/singleProduct";
import RazorPay from "../Components/razorPay";
import ProductPass from "../Pages/Products/ProductPass";
import UserLoyalty from "../Pages/User/loyalty";
import UserFollowing from "../Pages/User/following";
import UserSettings from "../Pages/userSettings";
import BuyNow from "../Pages/Membership/BuyNow";
import Offerslist from "../Pages/Offers/offerslist";
import { initializeApp } from "firebase/app";
// import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useEffect } from "react";
import OfferCard from "../Pages/Offers/offercard";
import Singleofferdetails from "../Pages/Offers/singleofferdetails";
import OfferBooking from "../Pages/Offers/offerBooking";
import MembershipCard from "../Components/MembershipCard/MembershipCard";
import VendorMembership from "../Pages/Membership/VendorMembership";
import MembershipBuyNow from "../Pages/Membership/MembershipBuyNow";
import MemberShipDetails from "../Pages/Membership/MemberShipDetails";
import MembershipBooking from "../Pages/Membership/membershipBooking";
import Paynow from "../Pages/Membership/Paynow";
import LoyaltyOffer from "../Pages/Loyalty/LoyaltyOffer";
import PinglePoints from "../Pages/Loyalty/PinglePoints";
import MerchantLoyalty from "../Pages/Loyalty/MerchantLoyalty";


import EditProfileEmailVerifyOtp from "../Pages/User/profile-edit/editProfileEmailVerifyOtp";
import BookingHistory from "../Pages/Booking/bookingHistory";
import UserBookingDetails from "../Pages/Booking/bookingDetails";
import SingleChat from "../Pages/Messenger/singleChat";
import BookingChat from "../Pages/Messenger/bookingChat";
import EnqueryChat from "../Pages/Messenger/enqueryChat";
import AddDeliveryAddress from "../Pages/Products/AddDeliveryAddress";
import AddAddress from "../Pages/Booking/AddAddress";
import VehicleRegister from "../Pages/User/vehicleRegister";
import PetRegister from "../Pages/User/petRegister";
import InstallPrompt from "../Pages/InstallPrompt";
import PinglePointsHistory from "../Pages/Loyalty/pointsHistory";
import SingleLoyaltydetail from "../Pages/Loyalty/singleLoyaltydetail";
import Redeemed from "../Pages/Loyalty/Redeemedlist";
import RedeemedDetails from "../Pages/Loyalty/RedeemedDetails";
import RegistrationAlert from "../Pages/Alerts/registrationAlert";
import CameraScan from "../Components/Camera/CameraScan";
import SearchMerchant from "../Pages/Scanner/SearchMerchant";
import QRCodeScan from "../Pages/Scanner/QRCodeScan";
import Scanner from "../../src/Components/Scanner";
import WebcamCaptureWithCrop from "../Components/Camera/Camera";
import SingleRefrelPointsdetail from "../Pages/Loyalty/SingleRefrelPointsdetails";
import DeliveryTime_Slot from "../Components/DeliveryTImeslot/DelivrySlot";
import Single_service_detail from "../Pages/Booking/single_service_detail";
import Coupon_card_list from "../Pages/Coupon/coupon_list";
import TicketList from "../Pages/PreOrder/TicketList";
import Single_preorder_detail from "../../src/Pages/PreOrder/Single_preorder_detail";
import Preorder_Buynow from "../Components/PreOrderTicketCard/Preorder_Buynow";
import DeliveryFlow from "../Pages/Map live tracking/Delivery_Flow";
import { auth } from "../Services/firebase-service/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import Get_currentLocation from "../Pages/Search/map_testing";
import My_coupon_list from "../Pages/Coupon/my_coupon_list";
import Kitchen_ticket_list from "../Pages/KitchenBooking/kitchen_ticket_list";
import Single_kitchen_ticket_detail from "../Pages/KitchenBooking/single_ticket_details";
import Kitchen_ReviewPay from "../Pages/KitchenBooking/Kitchen_ReviewPay";
import Kitchen_OrderPass from "../Pages/KitchenBooking/kitchen_OrderPass";
import ValidationRoute from "../Pages/Auth/ValidationRoute";
import PaymentCompleted from "../Pages/PaymentCompleted";
import SingleDomainSearch from "../Components/searchComponents/singleDomainSearch";
import MembershipSearch from "../Components/offCanvas/membershipSearch";
import OfferSearch from "../Components/offCanvas/offerSearch";
import Kitchen_MemberShip_List from "../Pages/KitchenBooking/kitchen_Membership/kitchen_MemberShip_List";
import Kitchen_Membership_detail from "../Pages/KitchenBooking/kitchen_Membership/kitchen_Membership_Details";
import Kitchen_MymembershipList from "../Pages/KitchenBooking/kitchen_Membership/Kitchen_Mymembership_List";
import LoginWithNumber from "../Pages/Auth/LoginWithNumber";
import PasswordForgot from "../Pages/Auth/PasswordForgot";
import ChangePassword from "../Pages/Auth/ChangePassword";
import CodeVerification from "../Pages/Auth/CodeVerification";
import VerifyForgotOtp from "../Pages/Auth/VerifyForgotOtp";
import Login from "../Pages/Auth/login";
import UserRegister from "../Pages/Auth/userRegister";
import Wallet from "../Pages/User/wallet/wallet";
import WalletHistory from "../Pages/User/wallet/walletHistory";
import VendorTokenHistory from "../Pages/User/wallet/VendorTokenHistory";
import VendorsTokensList from "../Pages/User/wallet/vendorsTokensList";





export default function AppRoutes() {
    useEffect(() => {
        signInWithEmailAndPassword(auth, "episodetechnologies@gmail.com", "Gangster003")
            .then((userCredential) => {
                const user = userCredential.user;
            })
            .catch((error) => {
                console.error("Error signing in:", error.message);
            });
    }, []);

    useEffect(() => {

        const handler = (e) => {
            e.preventDefault();
        };
        window.addEventListener('beforeinstallprompt', handler);
        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
        };
    }, []);

    return (

        <BrowserRouter>
            <ValidationRoute />
            <ToastContainer limit={1} />

            <Routes>
                {/*Auth*/}
                <Route path="/login" element={<Login />} />
                <Route path="/login-With-Number" element={<LoginWithNumber />} />
                <Route path="/forgot-password" element={<PasswordForgot />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/otpVerification" element={<OtpVerification />} />
                <Route path="/code-verification" element={<CodeVerification />} />
                <Route path="/verify-Forgot-Otp" element={<VerifyForgotOtp />} />
                <Route path="/user-Register" element={<UserRegister />} />

                {/* Booking */}
                <Route path="/" element={<BookingsManager />} />
                <Route path="/details/:id" element={<UserBookingDetails />} />
                {/* User */}
                <Route path="/dashboard" element={<UserDashboard />} />
                <Route path="/profile" element={<UserProfile />} />
                <Route path="/bulletin-board" element={<BulletinBoard />} />
                <Route path="/edit-profile" element={<EditProfileMenu />} />
                <Route path="/edit-profile/user" element={<EditProfileUser />} />
                <Route path="/edit-profile/email-verify" element={<EditProfileEmailVerify />} />
                <Route path="/edit-profile/email-otp-verify" element={<EditProfileEmailVerifyOtp />} />
                <Route path="/edit-profile/aadhar" element={<EditProfileAadhar />} />
                <Route path="/add-family-member" element={<AddFamilyMember />} />
                <Route path="/pet-register" element={<PetRegister />} />
                <Route path="/vehicle-register" element={<VehicleRegister />} />
                <Route path="/transactions" element={<Transactions />} />
                <Route path="/aboutPingle" element={<AboutPingle />} />
                <Route path="/settings" element={<UserSettings />} />
                <Route path="/UserFollowing" element={<UserFollowing />} />

                {/* Alerts */}
                <Route path="/registration-success" element={<RegistrationAlert />} />

                {/* Store Profile & booking  */}
                <Route path="/vendor/:vendor_id" element={<VendorProfile />} />
                <Route path="/store-profile/:vendor_id" element={<StoreProfile />} />
                <Route path="/door-step-service/:vendor_id" element={<DoorstepService />} />
                <Route path="/select-staff/:vendor_id" element={<BookingSelectStaff />} />
                <Route path="/review-and-pay/:vendor_id" element={<ReviewAndPay />} />
                <Route path="/history/:vendor_id" element={<BookingHistory />} />
                <Route path="/single_service_detail/:service_id" element={<Single_service_detail />} />

                {/* Messenger  */}
                <Route path="/messenger-list" element={<MessengerList />} />
                <Route path="/chat/:sender_id" element={<SingleChat />} />
                <Route path="/chat/booking/:chat_id" element={<BookingChat />} />
                <Route path="/chat/enquery/:enquery_id" element={<EnqueryChat />} />
                <Route path="/notifications" element={<NotificationList />} />

                {/* Search  */}
                <Route path="/map-view" element={<MapView />} />
                <Route path="/find-location" element={<FindLocation />} />
                <Route path="/membership-search" element={<MembershipSearch />} />
                <Route path="/offer-search" element={<OfferSearch />} />
                <Route path="/search-store" element={<SearchStoreProfile />} />

                {/* Products  */}
                <Route path="/ReviewPay" element={<ReviewPay />} />
                <Route path="/productBasket" element={<ProductBasket />} />
                <Route path="/ProductPass/:order_id" element={<ProductPass />} />
                <Route path="/RazorPay" element={<RazorPay />} />

                {/* Member ship */}
                <Route path="/MembershipCard" element={<MembershipCard />} />
                <Route path="/BuyNow" element={<BuyNow />} />
                <Route path="/MemberShipDetails/:vendorId/:membership_ID" element={<MemberShipDetails />} />
                <Route path="/my-membership" element={<UserMembership />} />
                <Route path="/VendorMembership" element={<VendorMembership />} />
                <Route path="/MembershipBuyNow/:vendorId" element={<MembershipBuyNow />} />
                <Route path="/MembershipBooking" element={<MembershipBooking />} />
                <Route path="/Paynow" element={<Paynow />} />

                {/* Offer Module */}
                <Route path="/Offerlist/:vendorId" element={<Offerslist />} />
                <Route path="/Offercard" element={<OfferCard />} />
                <Route path="/OfferDetails/:vendorId/:offerid" element={<Singleofferdetails />} />
                <Route path="/book-now/:vendorId" element={<OfferBooking />} />

                {/* Preorder Module */}
                <Route path="/TicketList/:vendorId" element={<TicketList />} />

                {/* Products  */}
                <Route path="/products/:vendor_id" element={<Products />} />
                <Route path="/productBasket" element={<ProductBasket />} />
                <Route path="/product/:vendorId/:productid" element={<SingleProduct />} />
                <Route path="/RazorPay" element={<RazorPay />} />
                <Route path="/AddDeliveryAddress" element={<AddDeliveryAddress />} />
                <Route path="/AddAddress" element={<AddAddress />} />

                {/* Loyalty */}
                <Route path="/PinglePointsHistory" element={<PinglePointsHistory />} />
                <Route path="/LoyaltyOffer" element={<LoyaltyOffer />} />
                <Route path="/PinglePoints" element={<PinglePoints />} />
                <Route path="/merchant-loyalty/:vendorId" element={<MerchantLoyalty />} />
                <Route path="/singleLoyaltydetails/:vendorId/:offerid" element={<SingleLoyaltydetail />} />
                <Route path="/redeemedlist" element={<Redeemed />} />
                <Route path="/RedeemedDetails" element={<RedeemedDetails />} />
                <Route path="/SingleRefrelPointsdetail" element={<SingleRefrelPointsdetail />} />

                {/* Scanner */}
                <Route path="/CameraScan" element={<CameraScan />} />
                <Route path="/SearchMerchant" element={<SearchMerchant />} />
                <Route path="/QRCodeScan" element={<QRCodeScan />} />
                <Route path="/Scan" element={<Scanner />} />

                {/* Camera  */}
                <Route path="/WebcamCaptureWithCrop" element={<WebcamCaptureWithCrop />} />
                <Route path="/Delivery_Time_Slot" element={<DeliveryTime_Slot />} />

                {/* Coupon */}
                <Route path="/Coupon_list/:vendor_id" element={<Coupon_card_list />} />
                <Route path="/my_coupon_list" element={<My_coupon_list />} />
                <Route path="/single_tickt_detail/:vendor_id/:ticket_id" element={<Single_preorder_detail />} />
                <Route path="/pre_order_buynow/:vendor_id" element={<Preorder_Buynow />} />
                <Route path="/live_traking/:order_id" element={<DeliveryFlow />} />
                <Route path="/get_currentLocation" element={<Get_currentLocation />} />
                <Route path="/payment-completed" element={<PaymentCompleted />} />

                {/*Hub*/}
                <Route path="/kitchen_ticket_list/:vendor_id" element={<Kitchen_ticket_list />} />
                <Route path="/ticket/:vendor_id/:ticket_id" element={<Single_kitchen_ticket_detail />} />
                <Route path="/Review-Pay" element={<Kitchen_ReviewPay />} />
                <Route path="/order-pass/:order_id" element={<Kitchen_OrderPass />} />
                <Route path="/domain-based-fillter" element={<SingleDomainSearch />} />

                {/*Kitchen flow*/}
                <Route path="/food-memberships/:vendor_id" element={<Kitchen_MemberShip_List />} />
                <Route path="/food-membership-detail/:vendor_id/:membership_ticket_id" element={<Kitchen_Membership_detail />} />
                <Route path="/my-food-memberships" element={<Kitchen_MymembershipList />} />

                {/* Wallet */}
                <Route path="/my-wallet" element={<Wallet />} />
                <Route path="/wallet-history" element={<WalletHistory />} />
                <Route path="/vendor-wallet-history/:vendor_id" element={<VendorTokenHistory />} />
                <Route path="/vendors-token" element={<VendorsTokensList />} />

            </Routes>
        </BrowserRouter>

    );
}

